import { Canvas } from '../interface/Canvas.ts';

class GetListCanvasResponse {
	listCanvas: Canvas[];

	constructor(listCanvasData: Canvas[]) {
		this.listCanvas = listCanvasData;
	}

	formatListCanvasData() {
		if (Array.isArray(this.listCanvas)) {
			return this.listCanvas.map((canvas) => ({
				id: canvas.canvas_id,
				imageUrl: canvas.image_url,
				name: canvas.name,
				status: canvas.status,
				updatedAt: canvas.updated_at,
				position: canvas.position,
				scale: canvas.scale,
				isPublic: canvas.public,
			}));
		}
		return [];
	}
}

export default GetListCanvasResponse;
